import { render, staticRenderFns } from "./lrNewEditor.vue?vue&type=template&id=c485fa8c&scoped=true&"
import script from "./lrNewEditor.vue?vue&type=script&lang=js&"
export * from "./lrNewEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c485fa8c",
  null
  
)

export default component.exports